export default () => {
  $(window).scroll(function () {
		var h = jQuery(this).height();
		if (jQuery(this).scrollTop() > (h-100)) {
			jQuery('#header').slideDown('fast');
		} else {
			jQuery('#header').slideUp('fast');
		}
	});
};



// WEBPACK FOOTER //
// ./src/assets/js/utilities/scrollHeader.js